import type { INotification } from '@magicbell/react-headless';
import * as React from 'react';

import { parseFormatString } from '@gitbook/app-notifications';

export interface NotificationTextProps {
    notification: INotification;
}

/**
 * Title component to render a notification's title or content with emphasis based on a special format
 * encoded as HTML directly into the notification's content.
 */
export function NotificationFormattedTitle(props: NotificationTextProps) {
    const { notification } = props;

    const content = React.useMemo(() => {
        return parseFormatString(notification.content || notification.title);
    }, [notification.content, notification.title]);

    return (
        <div className={notification.isRead ? 'text-muted' : undefined}>
            {content.map((part, index) => {
                return (
                    <React.Fragment key={index}>
                        {part.bold ? <strong>{part.text}</strong> : <span>{part.text}</span>}
                        {index < content.length - 1 ? ' ' : ''}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
